import CtaBanner from '@rsa-digital/evo-shared-components/components/CtaBanner';
import styled from 'styled-components';

export const StyledCtaBanner = styled(CtaBanner)`
  &&& {
    margin: 0;
  }
`;
